import React from "react";
// @material-ui/core components
import { makeStyles } from 'tss-react/mui';

// core components
import styles from "../styles/jss/nextjs-material-kit/pages/landingPageSections/pageDetailStyle.js";
import { SanitizeHTML } from "../util/string";

const useStyles = makeStyles()(styles);

export default function PageDetails({ page }) {
  const { classes, cx } = useStyles();
  return (
    <>
        <h1 className={classes.cardTitle}>
          {page.title}
        </h1>

        <SanitizeHTML html={page?.content} className="user-content" />
    </>
  );
}
